import { Switch, RouteComponentProps, Redirect } from "react-router-dom";
import { Route } from "components/utils";
import { NotFound } from "pages/notFound";
import { ManufacturingPlansList } from "pages/manufacturingNew/manufacturingPlans/ManufacturingPlansList";
import { getTabs } from "pages/manufacturingNew/manufacturingPlans/utils/getTabs";

export const ManufacturingPlans = ({ match }: RouteComponentProps) => {
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/list/${getTabs()[0].name}`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list`}
        render={() => <Redirect to={`${match.path}/list/${getTabs()[0].name}`} />}
      />
      <Route
        exact={true}
        path={`${match.path}/list/:tab`}
        component={ManufacturingPlansList}
        title="Milo - zlecenia produkcyjne"
      />

      <Route exact={true} path="*" component={NotFound} title="Milo" />
    </Switch>
  );
};
